/** Rails' CSRF token, for fetch() calls to JSON endpoints. */
export function csrfToken() {
  if (typeof document === "undefined") return ""
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}
